module.exports = __webpack_public_path__ + "static/media/moneycontrol_sdk_logo.9fd720e4.svg";